
import React, { useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function AsbestosBriefing() {
  const [form, setForm] = useState({
    location: "",
    office: "",
    surname: "",
    firstName: "",
    jobTitle: "",
    placeOfWork: "",
    subject: "",
    briefingBy: ""
  });

  // Dynamic signature blocks
  const [signatures, setSignatures] = useState([
    { date: "", signature: "", ref: React.createRef() }
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignatureChange = (idx, field, value) => {
    setSignatures(prev => {
      const updated = [...prev];
      updated[idx][field] = value;
      return updated;
    });
  };

  const clearSignature = (idx) => {
    const ref = signatures[idx].ref;
    if (ref.current) ref.current.clear();
    setSignatures(prev => {
      const updated = [...prev];
      updated[idx].signature = "";
      return updated;
    });
  };

  const saveSignature = (idx) => {
    const ref = signatures[idx].ref;
    if (ref.current && !ref.current.isEmpty()) {
      setSignatures(prev => {
        const updated = [...prev];
        updated[idx].signature = ref.current.getTrimmedCanvas().toDataURL("image/png");
        return updated;
      });
    }
  };

  const addSignatureBlock = () => {
    setSignatures(prev => [...prev, { date: "", signature: "", ref: React.createRef() }]);
  };

  const removeSignatureBlock = () => {
    if (signatures.length > 1) {
      setSignatures(prev => prev.slice(0, -1));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Asbestos Briefing Form submitted!");
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
       
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            Asbestos Briefing
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              <div className="col-md-6">
                <label className="form-label">Location of Induction</label>
                <input type="text" className="form-control" name="location" value={form.location} onChange={handleChange} required placeholder="Location of Induction"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-6">
                <label className="form-label">Office</label>
                <input type="text" className="form-control" name="office" value={form.office} onChange={handleChange} required placeholder="Office"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-12 mt-3">
                <div className="fw-bold text-left" style={{ color: "#8b1634", fontSize: "1.15rem" }}>
                  We the undersigned confirm that we have been briefed and understand the document(s) as detailed above
                </div>
              </div>
           
              {/* Dynamic Signature Sections */}
              {signatures.map((sig, idx) => (
                <div className="col-12 mt-3" key={idx}>
                  <div className="card p-3" style={{ background: "#faf9fa", borderRadius: "18px", border: "1.5px solid #eaf0fe" }}>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label">Surname</label>
                        <input type="text" className="form-control" name={`signatureSurname${idx}`} value={sig.surname || ''} onChange={e => handleSignatureChange(idx, "surname", e.target.value)} required placeholder="Surname"
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">First Name</label>
                        <input type="text" className="form-control" name={`signatureFirstName${idx}`} value={sig.firstName || ''} onChange={e => handleSignatureChange(idx, "firstName", e.target.value)} required placeholder="First Name"
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Job Title & Department</label>
                        <input type="text" className="form-control" name={`signatureJobTitle${idx}`} value={sig.jobTitle || ''} onChange={e => handleSignatureChange(idx, "jobTitle", e.target.value)} required placeholder="Job Title & Department"
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Place of Work</label>
                        <input type="text" className="form-control" name={`signaturePlaceOfWork${idx}`} value={sig.placeOfWork || ''} onChange={e => handleSignatureChange(idx, "placeOfWork", e.target.value)} required placeholder="Place of Work"
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Subject</label>
                        <input type="text" className="form-control" name={`signatureSubject${idx}`} value={sig.subject || ''} onChange={e => handleSignatureChange(idx, "subject", e.target.value)} required placeholder="Subject"
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Date</label>
                        <input type="date" className="form-control" name={`signatureDate${idx}`} value={sig.date} onChange={e => handleSignatureChange(idx, "date", e.target.value)} required
                          style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Signature</label>
                        <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', textAlign: 'left', position: 'relative', minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <SignatureCanvas
                            ref={sig.ref}
                            penColor="#8b1634"
                            backgroundColor="#e9cfd6"
                            clearOnResize={false}
                            velocityFilterWeight={0.7}
                            minWidth={1}
                            maxWidth={2.5}
                            dotSize={1.5}
                            throttle={16}
                            canvasProps={{ width: window.innerWidth > 600 ? 350 : 300, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }}
                            onEnd={() => saveSignature(idx)}
                          />
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                            <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }} onClick={() => clearSignature(idx)}>Clear</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {/* Add/Remove buttons for signature section */}
              <div className="d-flex justify-content-end gap-3 mt-3">
                <button
                  type="button"
                  className="btn btn-circle"
                  style={{ fontSize: '1.3rem', width: '36px', height: '36px', borderRadius: '50%', background: signatures.length === 1 ? '#eaeaea' : '#8b1634', color: signatures.length === 1 ? '#aaa' : '#fff', border: 'none', boxShadow: '0 2px 8px rgba(139,22,52,0.10)', transition: 'background 0.2s, color 0.2s', cursor: signatures.length === 1 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onClick={removeSignatureBlock}
                  disabled={signatures.length === 1}
                  title="Remove signature section"
                >
                  <i className="fa fa-minus" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-circle"
                  style={{ fontSize: '1.3rem', width: '36px', height: '36px', borderRadius: '50%', background: '#8b1634', color: '#fff', border: 'none', boxShadow: '0 2px 8px rgba(139,22,52,0.10)', transition: 'background 0.2s, color 0.2s', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onClick={addSignatureBlock}
                  title="Add signature section"
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
              {/* Briefing Conducted by & Date & Signature */}
              <div className="col-md-4 mt-4">
                <label className="form-label">Briefing Conducted by</label>
                <input type="text" className="form-control" name="briefingBy" value={form.briefingBy} onChange={handleChange} required placeholder="Briefing Conducted by"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" name="briefingDate" value={form.briefingDate || ''} onChange={handleChange} required placeholder="Date"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Signature</label>
                <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', textAlign: 'left', position: 'relative', minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <SignatureCanvas
                    ref={React.createRef()}
                    penColor="#8b1634"
                    backgroundColor="#e9cfd6"
                    clearOnResize={false}
                    velocityFilterWeight={0.7}
                    minWidth={1}
                    maxWidth={2.5}
                    dotSize={1.5}
                    throttle={16}
                    canvasProps={{ width: window.innerWidth > 600 ? 350 : 300, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }}
                  />
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                    <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }}>Clear</button>
                  </div>
                </div>
              </div>
              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2" style={{ backgroundColor: "#8b1634", borderRadius: "30px", boxShadow: "0 4px 12px rgba(139,22,52,0.3)" }}>Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AsbestosBriefing;
